import React from 'react'
import { Link } from 'react-router-dom'

export const Button = ({ className, link, text, img, pdf, imgHover}) => {
    return (
        <>
            {pdf ?
                <a className={className} href={pdf} target='_blank'>
                    <button>
                        <p>
                            {text}
                        </p>
                        <img className="img-no-hover" src={img} />
                        <img className="img-hover"src={imgHover} />
                    </button>
                </a>
                :
                <Link to={link} className={className}>
                    <button>
                        <p>
                            {text}
                        </p>
                        <img className="img-no-hover" src={img} />
                        <img className="img-hover"src={imgHover} />
                    </button>

                </Link>}
        </>
    )
}

